import { defineMessages } from "react-intl"

export const createExposeModalMessages = defineMessages({
	cancel: {
		defaultMessage: "Cancel",
		id: "createExposeModal.cancel",
	},
	create: {
		defaultMessage: "Create",
		id: "createExposeModal.create",
	},
	headline: {
		defaultMessage: "Create Exposé (PDF)",
		id: "createExposeModal.headline",
	},
	headline_offer: {
		defaultMessage: "Create Offer",
		id: "createExposeModal.headline.offer",
	},
	languageSubheadline: {
		defaultMessage: "Choose the language in which you want to create the exposé.",
		id: "createExposeModal.language.subheadline",
	},
	languageSubheadline_offer: {
		defaultMessage: "Choose the offer language.",
		id: "createExposeModal.language.subheadline.offer",
	},
	sectionSpecialEquipment: {
		defaultMessage: "Selected Equipment",
		id: "createExposeModal.sectionSpecialEquipment",
	},
	sectionStandardEquipment: {
		defaultMessage: "Standard Equipment",
		id: "createExposeModal.sectionStandardEquipment",
	},
	sectionTechnicalData: {
		defaultMessage: "Technical data",
		id: "createExposeModal.sectionTechnicalData",
	},
	sectionTyreLabels: {
		defaultMessage: "Tyre Labels",
		id: "createExposeModal.sectionTyreLabels",
	},
	sectionVehicleImages: {
		defaultMessage: "Vehicle images",
		id: "createExposeModal.sectionVehicleImages",
	},
	subtitle: {
		defaultMessage: "Select the content you want to include in the exposé.",
		id: "createExposeModal.subtitle",
	},
	subtitle_offer: {
		defaultMessage: "Select the content you want to include in the Offer.",
		id: "createExposeModal.subtitle.offer",
	},
})
